module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row",
    class: _vm.$style.root
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "row pill campaign-status",
    attrs: {
      "data-statuscode": _vm.campaign.baseStatus.code
    }
  }, [_vm._v("STATUS: " + _vm._s(_vm.statusName))]), _vm._l((_vm.activeIssues), function(issue) {
    return [_c('div', {
      staticClass: "row pill campaign-issue"
    }, [_vm._v(_vm._s(_vm.$t(("terms.issues." + issue + ".title"))))])]
  })], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fd21d550"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/campaign-status/CampaignStatus.vue
// module id = 2103
// module chunks = 1